export class UpdateIssueStateError extends Error {
    
}